import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PastorRegistration from '../components/PastorRegistration';
import { pastors } from '../data/pastors';
import './Sos.css';

export default function Sos() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="body">
      <Helmet><title>牧師リスト | ASMRキリスト教会</title></Helmet>
      <Header />
      <main className="sos-page">
        <Link className="sos-page__back" to="/">← HOME</Link>
        <h1>牧師リスト</h1>
        <div className="sos-page__table-wrap" role="region" aria-label="牧師の連絡先（横スクロールできます）" tabIndex={0}>
          <table className="sos-page__table" aria-label="牧師リスト">
            <thead>
              <tr>
                <th scope="col">名前</th>
                <th scope="col">所属教会</th>
                <th scope="col">信仰分類</th>
                <th scope="col">メールアドレス</th>
                <th scope="col">電話番号</th>
                <th scope="col">地域</th>
              </tr>
            </thead>
            <tbody>
              {pastors.map((pastor) => (
                <tr key={pastor.id}>
                  <th scope="row"><a href={pastor.contactUrl} target="_blank" rel="noopener noreferrer">{pastor.name}</a></th>
                  <td>{pastor.church || '未確認'}</td>
                  <td>{pastor.faithCategory || '未確認'}</td>
                  <td><a href={`mailto:${pastor.email}`}>{pastor.email}</a></td>
                  <td><a href={pastor.phoneHref}>{pastor.phone}</a>{pastor.phoneHours && <small>（{pastor.phoneHours}）</small>}</td>
                  <td>{pastor.region}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <PastorRegistration />
      </main>
      <Footer />
    </div>
  );
}
